import { render, staticRenderFns } from "./SubcategoriasContas.vue?vue&type=template&id=75851606&"
import script from "./SubcategoriasContas.vue?vue&type=script&lang=js&"
export * from "./SubcategoriasContas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports